define('fukit/view/block/notpageable.table.view',['require','exports','module','backbone','uikit/uikit','./basic.table.view','../../helpers/extend.util'],function(require, exports, module) {
    //prettier-ignore
    var Backbone             = require('backbone'),
        UIKit                = require('uikit/uikit'),
        BasicTableView       = require('./basic.table.view'),
        ExtendUtil           = require('../../helpers/extend.util');

    var NotPageableTableView = UIKit.ItemView.extend({
        template: function() {
            return '<ui name="tableView" /><ui name="noPaginationView" />';
        },

        options: {
            attached: false,
            simplePagination: false,
            alwaysShowEnds: false,
        },

        internalViewOptions: {
            tableView: ExtendUtil.extendOptionValueWithDefaults('table', function() {
                return {
                    type: BasicTableView,
                    collection: this.getOption('collection'),
                    columns: this.columns,
                };
            }),
         },

        addColumn: function(column) {
            if (this.tableView) {
                this.tableView.columns.add(column);
            }
        },

        internalViewBindings: {
            tableView: {
                attached: 'attached',
                collection: 'collection',
            },
        },
    });

    module.exports = NotPageableTableView;
});


